module.exports = __webpack_public_path__ + "img/private-pizzeriano3-nachspeisen.4424fffb.jpg";